import { CONSTANTS as LIVECHECK_CONSTANTS } from 'wanderu-ducks-live-check';

const {
    ERROR,
} = LIVECHECK_CONSTANTS;

const DEPART_DIRECTION = 'depart';
const RETURN_DIRECTION = 'return';

const TRAVELER_TYPE = 'traveler';
const TRIP_SUMMARY = 'trip-summary';
const WHEELCHAIR_TYPE = 'wheelchair-seat';

export {
    DEPART_DIRECTION,
    ERROR,
    RETURN_DIRECTION,
    TRAVELER_TYPE,
    TRIP_SUMMARY,
    WHEELCHAIR_TYPE,
};
